import { RATING_ADD_SUCCESS, RATING_ADD_FAILURE } from '../constants';
import { getAverageRating } from '../../helpers/ratingsHelper';

export const addRating = (dealId, rater, ratedUser, rating) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection('ratings')
      .add({
        dealId,
        rater,
        ratedUser,
        rating,
        timestamp: firestore.FieldValue.serverTimestamp()
      })
      .then(() => {
        updateUserRating(firestore, ratedUser);
        dispatch({ type: RATING_ADD_SUCCESS, payload: {} });
      })
      .catch(() => {
        dispatch({ type: RATING_ADD_FAILURE, payload: {} });
      });
  };
};

const updateUserRating = (firestore, ratedUser) => {
  firestore
    .collection('users')
    .doc(ratedUser)
    .get()
    .then(userDoc => {
      firestore
        .collection('ratings')
        .where('ratedUser', '==', userDoc.id)
        .get()
        .then(ratingSnapshots => {
          if (!ratingSnapshots.docs.length) {
            console.log('no ratings to update for user');
          } else {
            const ratings = ratingSnapshots.docs.map(ratingDoc => {
              return { ...ratingDoc.data(), id: ratingDoc.id };
            });
            const newRating = getAverageRating(ratings);
            userDoc.ref.update({
              rating: newRating
            });
          }
        });
    });
};



// WEBPACK FOOTER //
// ./src/store/actions/ratingActions.js